/**
 * srs-external-links.js
 *
 * サイト全体の <a> タグを走査し、外部リンクを別タブで開くようにする。
 *
 * 【対象】
 *   - http / https で、かつ同一 Shopify ストア外の URL
 *
 * 【対象外】
 *   - 同一ストア内（相対パス、カスタムドメイン、*.myshopify.com）
 *   - #アンカー、mailto:、tel:、javascript:、sms:
 *   - target="_self" が明示されているリンク
 *
 * 【設定】
 *   snippets/srs-external-links.liquid から window.srsInternalLinkHosts を注入。
 *   theme.liquid で読み込む。
 *
 * 【動的コンテンツ】
 *   MutationObserver で後から DOM に追加されたリンクにも適用（カートドロワー等）。
 */
(function () {
  /** 外部リンク判定から除外するプロトコル */
  var PROTOCOL_SKIP = ['mailto:', 'tel:', 'javascript:', 'sms:'];

  /**
   * ホスト名を比較用に正規化する
   * @param {string} host - ホスト名または URL 断片
   * @returns {string} 小文字のホスト名（例: "www.example.com"）
   */
  function normalizeHost(host) {
    if (!host) return '';
    return String(host)
      .replace(/^https?:\/\//i, '')
      .split('/')[0]
      .toLowerCase();
  }

  /**
   * 内部リンクとして扱うホスト一覧を返す
   * 現在のページ + Liquid 側で渡されたストアドメイン
   * @returns {string[]}
   */
  function getInternalHosts() {
    var hosts = [normalizeHost(window.location.hostname)];

    if (Array.isArray(window.srsInternalLinkHosts)) {
      window.srsInternalLinkHosts.forEach(function (host) {
        var normalized = normalizeHost(host);
        if (normalized) hosts.push(normalized);
      });
    }

    return hosts;
  }

  /**
   * 指定ホストが同一ストア内かどうか
   * @param {string} hostname
   * @returns {boolean}
   */
  function isInternalHost(hostname) {
    var host = normalizeHost(hostname);
    if (!host) return true;

    var internalHosts = getInternalHosts();
    for (var i = 0; i < internalHosts.length; i += 1) {
      if (host === internalHosts[i]) return true;
    }

    // カスタムドメイン閲覧時に myshopify.com 直リンクが別タブにならないよう除外
    return host.endsWith('.myshopify.com');
  }

  /**
   * href が外部リンクかどうか判定する
   * @param {string|null} href
   * @returns {boolean}
   */
  function isExternalHref(href) {
    if (!href) return false;

    var trimmed = href.trim();
    // 空・ページ内アンカー
    if (!trimmed || trimmed.charAt(0) === '#') return false;

    var lower = trimmed.toLowerCase();
    // mailto / tel 等
    for (var i = 0; i < PROTOCOL_SKIP.length; i += 1) {
      if (lower.indexOf(PROTOCOL_SKIP[i]) === 0) return false;
    }

    // ルート相対パス（/pages/... 等）は内部
    if (trimmed.charAt(0) === '/' && lower.indexOf('//') !== 0) return false;

    try {
      var url = new URL(trimmed, window.location.href);
      if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;
      return !isInternalHost(url.hostname);
    } catch (error) {
      return false;
    }
  }

  /**
   * 1 つの <a> に target="_blank" と rel を付与する
   * 二重処理防止のため data-srs-external-link を付ける
   * @param {HTMLAnchorElement} anchor
   */
  function enhanceLink(anchor) {
    if (!anchor || anchor.tagName !== 'A') return;
    if (anchor.hasAttribute('data-srs-external-link')) return;
    // 意図的に同タブ指定されている場合は尊重
    if (anchor.getAttribute('target') === '_self') return;

    var href = anchor.getAttribute('href');
    if (!isExternalHref(href)) return;

    anchor.setAttribute('target', '_blank');

    // 既存 rel を維持しつつ noopener / noreferrer を追加（タブナビング対策）
    var relParts = (anchor.getAttribute('rel') || '')
      .split(/\s+/)
      .filter(function (part) {
        return part;
      });

    if (relParts.indexOf('noopener') === -1) relParts.push('noopener');
    if (relParts.indexOf('noreferrer') === -1) relParts.push('noreferrer');
    anchor.setAttribute('rel', relParts.join(' '));
    anchor.setAttribute('data-srs-external-link', 'true');
  }

  /**
   * 指定要素配下のすべての <a> を処理する
   * @param {ParentNode} root
   */
  function enhanceLinks(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('a[href]').forEach(enhanceLink);
  }

  /** 初回走査 + 以降の DOM 追加を監視 */
  function init() {
    if (!document.body) return;

    enhanceLinks(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'A') {
            enhanceLink(node);
            return;
          }
          enhanceLinks(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
